import { useTranslation } from 'react-i18next';
import { Layers, MoreHorizontal, Presentation, Trash2 } from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

import { Space } from '../../../vendor/my-spaces/models/space.model';

/** A space's ⋯ menu, the same in the list and the grid. */
export function SpaceActionsMenu({
    space,
    name,
    onOpenInManager,
    onToggleDemo,
    onDelete,
}: {
    space: Space;
    /** The name shown for the space, for the button's accessible label. */
    name: string;
    onOpenInManager?: (space: Space) => void;
    /** Mark or unmark it as a room every new demo prospect gets. */
    onToggleDemo?: (space: Space) => void;
    onDelete: (space: Space) => void;
}) {
    const { t } = useTranslation();
    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant="ghost" size="icon-sm" aria-label={t('ADMIN_SPACES.ROW_ACTIONS', { name })}>
                    <MoreHorizontal />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="min-w-52">
                {onOpenInManager && (
                    <>
                        <DropdownMenuItem onClick={() => onOpenInManager(space)}>
                            <Layers />
                            {t('ADMIN_SPACES.OPEN_IN_MANAGER')}
                        </DropdownMenuItem>
                        <DropdownMenuSeparator />
                    </>
                )}
                {onToggleDemo && (
                    <>
                        <DropdownMenuItem onClick={() => onToggleDemo(space)}>
                            <Presentation />
                            {t(space.isDemoDefault ? 'ADMIN_SPACES.DEMO.UNMARK' : 'ADMIN_SPACES.DEMO.MARK')}
                        </DropdownMenuItem>
                        <DropdownMenuSeparator />
                    </>
                )}
                <DropdownMenuItem variant="destructive" onClick={() => onDelete(space)}>
                    <Trash2 />
                    {t('ADMIN_SPACES.DELETE')}
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
